import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { reorderArray } from '@app/helpers/myDevices/reorderArray'
import { GET_TWR_ALARM_OPTIONS } from '@app/constants/myDevices/twrDevices'
import { setTwrAlarmOptions } from '@app/actions/myDevices/twrDevices'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestFailed, apiRequestDone } from '@app/actions/apiRequest'
import Api from '@app/api/myDevices/deviceSettings/twrDevices'

const getTwrAlarmOptions = createLogic({
  type: GET_TWR_ALARM_OPTIONS,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    next({
      ...action,
      accessToken,
    })
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(GET_TWR_ALARM_OPTIONS))
    try {
      const alarmOptions = await Api.getTwrAlarmOptions(action.accessToken, action.id)
      dispatch(setTwrAlarmOptions(reorderArray(alarmOptions.data.options, 0, 2)))
      dispatch(apiRequestDone(GET_TWR_ALARM_OPTIONS))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('GET_TWR_ALARM_OPTIONS failed without error')
      }
    }
    done()
  },
})

export default getTwrAlarmOptions
